export const weekConfig = {
  weekDays: [0, 1, 2, 3, 4, 5, 6],
  weekStartOn: 0,
  startHour: 9,
  endHour: 20,
  step: 15,
  navigation: true,
  disableGoToDay: false,
};

export const dayConfig = {
  startHour: 9,
  endHour: 20,
  step: 15,
  navigation: true,
};

export const resourceFields = {
  idField: "user_id",
  textField: "user_name",
  subTextField: "location_name",
  avatarField: "user_name",
  colorField: "color",
};

export const getRandomColor = () => {
  const red = Math.floor(Math.random() * 151) + 50;
  const green = Math.floor(Math.random() * 151) + 50;
  const blue = Math.floor(Math.random() * 151) + 50;
  const color = `rgba(${red}, ${green}, ${blue})`;
  return color;
};

export const groupedSchedules = (data) => {
  const dataMapped = data.map((schedule) => {
    const size = Date.parse(schedule.end) - Date.parse(schedule.start);

    const allSameEvents = data.filter(
      (x) => x.appointmentId === schedule.appointmentId
    );

    let uniqueServicesForEvent = {};

    if (allSameEvents.length > 1) {
      uniqueServicesForEvent = allSameEvents.reduce((acc, schedule) => {
        if (acc[schedule.service_id]) {
          return acc;
        } else {
          acc[schedule.service_id] = {
            service_id: schedule.service_id,
            title: schedule.title,
            service_shortcut: schedule.service_shortcut,
            service_color: schedule.service_color,
          };
          return acc;
        }
      }, {});
    } else {
      uniqueServicesForEvent = [
        {
          service_id: schedule.service_id,
          title: schedule.title,
          service_shortcut: schedule.service_shortcut,
          service_color: schedule.service_color,
        },
      ];
    }

    if (schedule.appointmentId === null) {
      return {
        appointmentId: schedule.appointmentId,
        start: new Date(schedule.start),
        end: new Date(schedule.end),
        event_id: schedule.appointmentId,
        title: schedule.client_name,
        user_id: schedule.user_id,
        user_name: schedule.user_name,
        client: {
          client_id: schedule.client_id,
          client_name: schedule.client_name,
        },
        location: {
          location_id: schedule.location_id,
          location_name: schedule.location_name,
          organization_id: schedule.organization_id,
        },
        uniqueServices: Object.values(uniqueServicesForEvent),
        services: [
          {
            event_id: schedule.event_id,
            service_id: schedule.service_id,
            title: schedule.title,
            service_shortcut: schedule.service_shortcut,
            service_color: schedule.service_color,
            serviceStart: schedule.start,
            serviceEnd: schedule.end,
            topOffset: 0,
            size: size * 100,
          },
        ],
      };
    } else {
      return {
        appointmentId: schedule.appointmentId,
        start: new Date(schedule.start),
        end: new Date(schedule.end),
        event_id: schedule.event_id,
        title: schedule.client_name,
        user_id: schedule.user_id,
        user_name: schedule.user_name,
        client: {
          client_id: schedule.client_id,
          client_name: schedule.client_name,
        },
        location: {
          location_id: schedule.location_id,
          location_name: schedule.location_name,
          organization_id: schedule.organization_id,
        },
        uniqueServices: Object.values(uniqueServicesForEvent),
        services: [
          {
            event_id: schedule.event_id,
            service_id: schedule.service_id,
            title: schedule.title,
            service_shortcut: schedule.service_shortcut,
            service_color: schedule.service_color,
            serviceStart: schedule.start,
            serviceEnd: schedule.end,
            topOffset: 0,
            size: size,
          },
        ],
      };
    }
  });

  return dataMapped;
};

export const SchedulerAPI = {
  //get: "gateway/68nkedd2v8", //Uses production/Live API
  // get: `gateway/fh3c0gu345`, //Uses Development API
  get: "scheduler",
  //create: "gateway/4l0utv3x1g",
  modify: "scheduler/updateAppointment",
  delete: "scheduler/deleteAppointment",
  move: "scheduler/updateAppointment",
};
